import { BodyM, HeadingS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React, { useState } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';
import CustomButton from 'components/CustomButtons/Button';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core/styles';
import SimpleFailureDialog from '../../common/SimpleFailureDialog';
import { NumbersService } from 'services/numbers/numbers';
import invalidateCache from 'utils/api/invalidateCache';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
// @ts-ignore
const useStyles = makeStyles(styles);

interface IDetachProfileDialogProps {
	masterNumber: string;
	phoneNumber: string;
}

const DetachProfileDialog = ({ masterNumber, phoneNumber }: IDetachProfileDialogProps) => {
	const classes = useStyles();
	const [dialogOpen, setDialogOpen] = useState('');
	const [detaching, setDetaching] = useState(false);
	const [hideOnSuccess, setHideOnSuccess] = useState(false);

	const deleteRelated = () => {
		setDetaching(true);
		NumbersService.detachNumberFromProfile(masterNumber, phoneNumber).subscribe(
			({ response }) => {
				if (response?.detachNumberFromProfileResponse?.response === 'success') {
					setDialogOpen('success');
					setDetaching(false);
					invalidateCache(['getCorpUserDepartmentDataForNumber']);
					setHideOnSuccess(true);
				} else {
					setDialogOpen('failure');
					setDetaching(false);
				}
			},
			() => {
				setDialogOpen('failure');
				setDetaching(false);
			}
		);
	};

	const hideDialog = () => {
		setDialogOpen('');
	};

	return (
		<>
			<ConditionalRender
				show={hideOnSuccess}
				onFalse={() => (
					<CustomButton color="tertiary-light" onClick={() => setDialogOpen('confirmation')} size="sm">
						{translate('numbers.details.numberRelated.delete')}
					</CustomButton>
				)}
			/>
			<ConfirmationDialog
				isOpen={dialogOpen === 'confirmation'}
				hideDialog={hideDialog}
				header={translate('numbers.details.numberRelated.dialog.header')}
				loading={detaching}
				dialogBody={
					<div>
						<BodyM color="secondary-light">
							{translate('numbers.details.numberRelated.dialog.description')}
						</BodyM>
					</div>
				}
				buttons={[
					{
						text: translate('no'),
						onClick: hideDialog,
						color: 'tertiary-light',
					},
					{
						text: translate('numbers.details.numberRelated.delete'),
						onClick: deleteRelated,
						color: 'primary-light',
					},
				]}
			/>
			<CustomConfirmationDialog
				isOpen={dialogOpen === 'success'}
				hideDialog={hideDialog}
				header={<BodyM>{translate('numbers.details.numberRelated.dialog.succesMessage')}</BodyM>}
			>
				<div className={classes.successDialogBody}>
					<HeadingS color="success" disableMargin>
						{translate('numbers.details.numberRelated.dialog.close')}
					</HeadingS>
				</div>
			</CustomConfirmationDialog>
			<SimpleFailureDialog isOpen={dialogOpen === 'failure'} hideDialog={hideDialog} />
		</>
	);
};

export default DetachProfileDialog;
